export default __webpack_public_path__ + "162f832f2df381d8a0a85687edef7527.png";